import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import setField from 'webapp/helpers/set-field';
import CommonPopupColorsContextComponent from 'webapp/components/common/popups/popup-colors';
import CommonUiIcon from 'webapp/components/common/ui-icon';
import FormInputComponent from 'webapp/components/form/input';
import {
	type ChunkArgs as BaseChunkArgs,
	type ChunkInterface,
} from 'webapp/components/notifications/edit/form/base';

import type { Scorecard } from 'webapp/models-custom';

interface TitleComponentArgs extends BaseChunkArgs {
	model: Scorecard;
	submitInProgress: boolean;
}

interface TitleComponentInterface extends ChunkInterface {
	Args: TitleComponentArgs;
}

export default class NotificationsEditFormScorecardTitleComponent extends Component<TitleComponentInterface> {
	@service('popup') declare popupService: Service.Popup;
	@service('constants') declare constantsService: Service.Constants;

	@action
	openColorPopup(e: PointerEvent) {
		const isPopupOpen = this.popupService.isOpen(CommonPopupColorsContextComponent);

		if (isPopupOpen) {
			return;
		}

		const attachTo = (e.target as HTMLElement)
			.closest('.color')
			?.querySelector<HTMLElement>('ui-icon');

		if (!attachTo) {
			return;
		}

		const allColors = this.constantsService.boardColors
			.filter((item) => item.name)
			.reduce(
				(colors, color) => {
					if (!color.isLight) {
						colors.push({
							id: color.hex,
							name: color.name,
							hex: color.hex,
						});
					}

					return colors;
				},
				[] as { id: string; name: string; hex: string }[],
			);

		const popup = this.popupService.createContext(CommonPopupColorsContextComponent, attachTo, {
			popupClass: 'popup-type-color popup-type-color--block',
			theme: 'dark',
		});

		const model = this.args.model;
		popup.open({
			selected: model.color,
			allColors,
			changeColor: (color: string | number) => {
				if (model && model.color !== color) {
					model.color = color as string;
				}
			},
		});
	}

	<template>
		<FormInputComponent
			name="name"
			@value={{@model.title}}
			maxlength="50"
			@onEmpty={{setField target=@model property="title"}}
			@hideFloatLabel={{true}}
			disabled={{@submitInProgress}}
		/>

		<a class="color" role="button" {{on "click" this.openColorPopup}}>
			<CommonUiIcon
				@name={{if @model.color "RaindropFill" "RaindropAuto"}}
				@size="sm"
				@fill={{@model.color}}
			/>
			<CommonUiIcon @name="ChevronDown" @size="sm" />
		</a>
	</template>
}
